import * as moment from 'moment';

export default class RealInterestRate {
    requiredPayment = 0;
    term = 0;
    results = [];
    iter = -1;

    constructor(requiredPayment, term, fullCreditSum) {
        this.requiredPayment = requiredPayment;
        this.term = parseInt(term);
        this.current = moment(new Date());
        this.fullCreditSum = fullCreditSum;
    }

    calculate() {
        this.calc();
        return this.results[this.results.length - 1].efRates;
    }

    calc() {
        let x = 1;
        for (let i = 0; i < 50; i++) {
            x = this.getX();
            this.newtonsMethod(x);
        }
    }

    /**
     * @Method Newton's method
     *
     * @param x
     */
    newtonsMethod(x) {
        const r = this.requiredPayment,
            s = this.fullCreditSum;

        let numerator = 0;
        let denominator = 0;
        let result = 0;
        let efRates = 0;
        let period = 0;

        for (let i = 1; i <= this.term; i++) {
            numerator = numerator + r * Math.pow(x, i);
            // numerator = `${numerator} + ${r} * x^${i}`;
            denominator = denominator + r * i * Math.pow(x, i - 1);
            // denominator = `${denominator} + (${r} * ${i} * ${x}^${i - 1}))`;
        }
        numerator = numerator - s;
        result = Math.abs(x - numerator / denominator);
        period = -1 / this.getPeriod();
        efRates = Math.abs(Math.pow(result, period) - 1);

        if (this.term > 2) {
            efRates = efRates - 0.01;
        }

        if (efRates < 0) {
            efRates = 0;
        }

        this.results.push({
            x: result,
            efRates
        });
        this.iter = this.iter + 1;
    }

    getX() {
        if (!this.results.length) {
            return 1;
        }

        return this.results[this.iter].x;
    }

    getPeriod() {
        return 30 / 365; // this.term;
    }
}
